define('modules/overview/view_player_loop_model',[
  'backbone',
  'jquery',
  '_',
  'session'
], function (Backbone, $, _, session) {
  'use strict';

  var ViewPlayerLoopModel = Backbone.Model.extend({
    playerId: '',
    playerName: '',
    date: '',
    time: '',
    url: function () {
      // Replace : char with - char in time string to avoid request getting caught in CORS rules.
      return session.get('apiUrl') + 'players/playlist/' + this.playerName + '/' + this.date + '/' + this.time.replace(':', '-');
    },
  });

  return ViewPlayerLoopModel;
});

